

@if (event !== null) {
  <div class="card card-default">
    <div class="card-header pb-5">
      <h2>{{ event.StartDateTime | localDateTime | slice:0:10 }}: {{ event.Name }}</h2>
    </div>
  </div>
}

@if (event === null && location !== null) {
  <div class="card card-default">
    <div class="card-header pb-5">
      <h2>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.TITLE' | translate}} {{location.Name}} ({{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.VERSION' | translate}}{{location.Version}})</h2>
    </div>
  </div>
}



<div class="row">
  <div class="col-lg-4 col-md-12">
    <app-section-selector
      (onSelected)="onVenueBuildingBlockSelected($event)"
      #sectionSelectorComponent>
    </app-section-selector>
  </div>


  <div class="col-lg-8 col-md-12">

    @if ((editingVBB != null)) {
      <div class="card card-default">
        @if (hasUnpublishedChanges === true) {
          <div class="publish-warning bg-primary">
            <div class="row">
              <div class="col-lg-7">
                {{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.WARNING.UNPLUBISHED' | translate}} {{location.Name}}
              </div>
              <div class="col-lg-5" style="text-align: right;">
                <t4-lro-button (onLROClick)="undo()" cssClasses="btn btn-danger border btn-small me-2" [icon]="'fas fa-undo'" [text]="'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.BUTTON.UNDO'" [lroTypeCode]="longRunningOperationTypeEnum.ApplyPendingVBBChanges"></t4-lro-button>
                <t4-lro-button (onLROClick)="publish()" (onLROComplete)="progressFinished()" cssClasses="btn btn-warning border btn-small" [icon]="'fas fa-upload'" [text]="'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.BUTTON.PUBLISH'" [lroTypeCode]="longRunningOperationTypeEnum.ApplyPendingVBBChanges"></t4-lro-button>
              </div>
            </div>
          </div>
        }
        <div class="card-header" >
          <h2>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TITLE' | translate}} {{ editingVBB | venueTitle | uppercase }}</h2>
        </div>
        <div class="card-body">
          <div class="object-actions mt-3">
            <div class="row">
              <div class="col-lg-3" style="text-align: left;">
                @if (eventPlacementEventId === null) {
                  <button style="margin-left: 0px;" (click)="openChangeLog()" [disabled]="nrOfChangeLogs == 0" class="btn btn-primary border btn-small" type="button"><i class="far fa-edit"></i>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.BUTTON.CHANGES' | translate}} ({{ nrOfChangeLogs }})</button>
                }
                @if (eventPlacementEventId === null) {
                  <span class="separator"></span>
                }
              </div>
              <div class="col-lg-9">
                @if (eventPlacementEventId === null && !isInArchiveMode) {
                  <button [disabled]="editingVBB.HasPlacements" (click)="copySection()" class="btn btn-primary border btn-small" type="button"><i class="far fa-edit"></i>{{'GENERIC.BUTTON.COPY' | translate}}</button>
                }
                <button (click)="editDetails()" class="btn btn-warning border btn-small" type="button"><i class="far fa-edit"></i>{{'GENERIC.BUTTON.EDIT' | translate}}</button>
                @if (eventPlacementEventId === null && !isInArchiveMode) {
                  <span class="separator"></span>
                }
                @if (eventPlacementEventId === null) {
                  <button (click)="deleteVBB()" [disabled]="editingVBB.HasPlacements"  class="btn btn-danger border btn-small" type="button"><i class="far fa-trash-alt"></i>{{'GENERIC.BUTTON.REMOVE' | translate}}</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }


    @if ((editingVBB != null)) {
      <div class="card"  >
        <div>
          <t4-tabs (selected)="onTabChange($event)">
            <t4-tab tabTitle="{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TAB.TICKET-POSTITION' | translate}}" id="positions"></t4-tab>
            <t4-tab tabTitle="{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TAB.ENTRANCES' | translate}}" id="entrances"></t4-tab>
            <t4-tab tabTitle="{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TAB.SECTION-FILTERS' | translate}}" id="filters"></t4-tab>
          </t4-tabs>
        </div>
      </div>
    }

    @if (editingVBB !== null) {
      @if (currentTabId == 'positions') {
        <div class="row mt-5">
          <div class="col-lg-3 col-md-12">
            <div class="card card-default mb-0">
              <div class="card-header">
                <h2>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.TITLE' | translate}}</h2>
              </div>
              <div class="card-body pt-0">
                <ul class="nav nav-settings">
                  @for (ticketType of ticketTypes; track ticketType; let i = $index) {
                    <li class="nav-item">
                      <a (click)="selectTicketType(ticketType, i)" [class.active]="ticketTypeIsSelected(ticketType)" class="clickable nav-link">
                        <i class="mdi mdi-account-outline me-1"></i> {{ ticketType.Name}}
                      </a>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-9 col-md-12">
            @if (sectionIsMixed()) {
              <div class="alert alert-warning mb-3" role="alert">
                {{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.MIXED-WARNING' | translate: { names: sectionTicketTypeNames() } }}
              </div>
            }
            @if (selectedTicketType !== null) {
              <div class="card card-default mb-0">
                <div class="card-header">
                  <h2>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.CARD-TYPES' | translate}} {{selectedTicketType.Name}}</h2>
                </div>
                <div class="card-body pt-0">
                  @if (tabIndex >= 0) {
                    @if (!canAddPositions(selectedTicketType)) {
                      <div class="alert alert-info mt-3 mb-0" role="alert">
                        {{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.HOLDS-OTHER-TYPE' | translate: { names: sectionTicketTypeNames() } }}
                      </div>
                    }
                    <!-- vbb has seats-->
                    @if (selectedTicketType.IsPlaced == 1 && endpointsAvailable(tabIndex)) {
                      <div>
                        <!-- Placed endpoint / placement grid -->
                        <div class="endpoints-places">
                          <div class="object-actions mt-3">
                            <button class="btn btn-primary border btn-small" title="{{'COMPONENTS.VENUE-PLACEMENTS-EDITOR.BUTTON.TITLE.EDIT-SEATPLAN' | translate}}" (click)="openSeatPlan(tabDetails[tabIndex].endpoints)" >
                              <i class="far fa-map"></i>
                              <span>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.CARD-TYPES.BUTTON.OPEN-SEATPLAN' | translate}}</span>
                            </button>
                            <span class="separator"></span>
                            <button class="btn btn-primary border btn-small" [disabled]="eventPlacementEventId !== null" title="{{'COMPONENTS.VENUE-PLACEMENTS-EDITOR.BUTTON.TITLE.CURRENT-SELECTION-SLASH-MANAGA-LOCATION' | translate}}" (click)="addTickets(selectedTicketType, tabIndex)" >
                              <i class="far fa-edit"></i>
                              <span>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.CARD-TYPES.BUTTON.EDIT-AMOUNT' | translate}}</span>
                            </button>
                          </div>
                          <p class="mt-3">
                            {{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.CARD-TYPES.CARDS-PLACED' | translate}}
                          </p>
                        </div>
                      </div>
                    }
                    @if (selectedTicketType.IsPlaced == 0) {
                      <div class="endpoints-places">
                        <app-unplaced-ticket-list [eventId]="eventPlacementEventId" [canAddPositions]="canAddPositions(selectedTicketType)" (onRefreshRequired)="onUnplacedTicketRefreshRequired($event)" [parent]="editingVBB" [ticketType]="selectedTicketType" [endpoints]="tabDetails[tabIndex].endpoints" [totalEndpoints]="tabDetails[tabIndex].allEndpoints" [soldTickets]="soldTickets"></app-unplaced-ticket-list>
                      </div>
                    }
                    <!-- end vbb has seats-->
                    @if (!endpointsAvailable(tabIndex) && selectedTicketType.IsPlaced == 1) {
                      <div>
                        <div class="object-actions mt-3">
                          @if (!isInArchiveMode) {
                            <button class="btn btn-primary border btn-small" [disabled]="eventPlacementEventId !== null || !canAddPositions(selectedTicketType)" (click)="addTickets(selectedTicketType, tabIndex)"  >
                              <i class="fa fa-plus-square"></i>
                              <span> {{'GENERIC.BUTTON.ADDNEW' | translate}}</span>
                            </button>

                          }
                        </div>
                        <p class="mt-3">
                          <span> {{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.CARD-TYPES.NO-CARDS-AVAILABLE' | translate}}</span>
                        </p>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (currentTabId == 'entrances') {
        <!-- BEGIN entrances -->
        <div class="card card-default">
          <div class="card-body">
            <form [formGroup]="entranceForm">
              <div fxFlex  class="pe-1" >
                <div class="form-group">
                  <input style="min-width: 400px;" class="form-control" placeholder="{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.TICKET-TYPE.ENTRENCES-SEARCH' | translate}}" [matAutocomplete]="auto" formControlName="entranceSearch">
                </div>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onEntranceAdd($event)">
                  @for (e of filteredEntrances; track e) {
                    <mat-option  [value]="e">
                      {{ e.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </div>
            </form>
            <div class="table-responsive bg-white">
              <table class="rounded table text-dark table-striped clickable">
                <thead>
                  <td>{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.ENTRENCES.HEADER.NAME' | translate}}</td>
                  @if (inSingleEntranceMode) {
                    <td style="width:150px">{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.ENTRENCES.HEADER.STANDARD' | translate}}</td>
                  }
                  <td>&nbsp;</td>
                </thead>
                <tbody>
                  @if (vbbEntrances !== null && vbbEntrances.length == 0) {
                    <tr>
                      <td colspan="3">{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.ENTRENCES.NOT-LINKED' | translate}}</td>
                    </tr>
                  } @else {
                    @for (entrance of vbbEntrances; track entrance) {
                      <tr>
                        <td>{{entrance.Name}}</td>
                        @if (inSingleEntranceMode) {
                          <td>
                            @if (entrance.IsDefault === false) {
                              <span></span>
                            }
                            @if (entrance.IsDefault === true) {
                              <i class="far fa-check-circle"></i>
                            }
                          </td>
                        }
                        <td class="grid-action pt-1" >
                          <div style="padding-top: 5px; ">
                            <ng-container >
                              @if (inSingleEntranceMode && !isInArchiveMode) {
                                <button  [disabled]="entrance.IsDefault === true"  (click)="markSelectedAsDefault(entrance)" type="button" class="btn btn-grid btn-round mdi mdi-primary mdi-check-circle-outline"></button>
                              }
                              @if (!isInArchiveMode) {
                                <button (click)="deleteEntrance(entrance)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
                              }
                            </ng-container>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- END Entrances-->
      }
      @if (currentTabId == 'filters') {
        <!-- BEGIN filters -->
        <div class="card card-default shadow-sm">
          <div class="card-header border-0 pb-0">
            <p class="text-uppercase text-muted small mb-0">{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.FILTER-GROUPS.CRITERIA.ACTIVE' | translate}}</p>
          </div>
          <div class="card-body pt-4">
            <div class="row align-items-start">
              <div class="col-lg-4 col-md-12">
                <form [formGroup]="filterForm" class="mb-3">
                  <div fxFlex class="pe-1">
                    <div class="form-group mb-3">
                      <input class="filter-search form-control" placeholder="{{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.FILTER-SEARCH' | translate}}" [matAutocomplete]="filterAuto" formControlName="filterSearch">
                    </div>
                    <mat-autocomplete #filterAuto="matAutocomplete" (optionSelected)="clickCriterionFromList($event.option.value)">
                      @for (e of filteredCriteria; track e) {
                        <mat-option [value]="e">
                          {{ e.Code | translate }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </div>
                </form>
                <div class="d-flex flex-wrap" style="gap: 0.5rem;">
                  <button type="button" class="btn btn-light btn-sm" [class.filter-group-selected]="selectedFilterGroup == null" (click)="selectAllFilterGroups()">
                    {{'LOCATION.VENUE-DEFINITION.VENUE-PLACEMENT.SECTION.FILTER-GROUPS.SELECT-ALL' | translate}}
                  </button>
                  @for (filterGroup of filterGroups; track filterGroup) {
                    <button type="button" class="btn btn-light btn-sm" [class.filter-group-selected]="selectedFilterGroup != null && filterGroup.Id === selectedFilterGroup.Id" (click)="selectFilterGroup(filterGroup.Id)">
                      {{filterGroup.Code | translate}}
                    </button>
                  }
                </div>
              </div>
              <div class="col-lg-8 col-md-12">
                <div class="mb-3">
                  <div class="d-flex flex-wrap" style="gap: 0.75rem;">
                    @for (criterion of selectedCriteria; track criterion) {
                      <button type="button" (click)="clickCriterion(criterion)" class="criterion-pill criterion-pill--active">
                        <span>{{ criterion.Code | translate }}</span>
                        <i class="fa-solid fa-circle-xmark"></i>
                      </button>
                    }
                  </div>
                </div>
                <hr class="pill-divider" />
                <div>
                  <div class="d-flex flex-wrap" style="gap: 0.75rem;">
                    @for (criterion of selectableCriteria; track criterion) {
                      <button type="button" [class.hide]="isCriterionSelected(criterion.Id)" (click)="clickCriterion(criterion)" class="criterion-pill criterion-pill--available">
                        <span>{{ criterion.Code | translate }}</span>
                        <i class="fa-solid fa-circle-plus"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer bg-transparent border-0 pt-0">
            <div class="row">
              <div class="col-12">
                @if (!isInArchiveMode) {
                  <button [disabled]="isFilterFormDirty() || saving" (click)="submitFilterChanges()" class="btn btn-primary border btn-block" type="button">
                    <i class="far fa-save"></i>{{'GENERIC.BUTTON.SAVE' | translate}}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
        <!-- END filters-->
      }
    }


  </div>
</div>



